function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M221.9,236.8c-1.6,0-3.2-0.2-4.7-0.6l-28.2-6.8c-8.6-2.1-18.5-13.5-21.3-18.9l-3.3-4.9 c-4.6-5.6-7.8-7-15.5-10.4l-3-1.3c-15.7-7-21.6-13.9-27.4-24.9c-3.1-5.9-4-11.6-2.5-16c1.1-3.3,3.4-5.9,6.7-7.5 c7-3.4,12.1-5.6,12.4-5.7l2.5,5.9c-0.1,0-5.2,2.2-12.1,5.6c-1.8,0.9-2.9,2.1-3.4,3.7c-0.9,2.7-0.1,6.7,2.1,11 c5.4,10.2,10.1,15.8,24.3,22l3,1.3c8,3.5,12.4,5.4,18.1,12.4l3.8,5.7c2.5,5.1,11.3,14.3,17.1,15.7l28.2,6.8 c5.5,1.3,10.7-0.6,16.3-6c1.3-1.2,4-4.2,6.1-7.5l5.4,3.5c-2.3,3.5-5.2,6.9-7.1,8.7C233.8,234,227.9,236.8,221.9,236.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M232.9,226.1c-6.6,0-14.7-2-24.2-4.2l-1.1-0.3c-16-3.8-27.3-12.6-33.9-26c-4.1-8.5-9.7-11.1-16.1-14.1 c-2.7-1.3-5.5-2.6-8.3-4.4c-6.8-4.5-21.9-21-17.1-33.6c1.1-3,3.5-6.6,5.7-8.6l0,0c1.9-1.8,17.4-13.5,21.9-15.9 c6.2-3.4,8.8-2.6,14.2-0.6l0.5,0.2c5,1.9,4,5.9,3.6,7.6c-0.5,1.9-1,4,1.8,7.7c5.1,6.8,11.9,5.9,16.8,5.3l1-0.1 c5-0.6,10.9-0.1,12.4,9.2c1.1,6.9,11.9,36.1,15.8,45.1c1.3,0.7,2.8,1.4,4.3,2.2c6.7,3.3,14.2,7.1,17.8,9.7 c1.7,1.2,2.7,3.2,2.6,5.6c-0.2,5-4.7,11.1-8.7,13.5l-0.3,0.2C239.1,225.6,236.2,226.1,232.9,226.1z M167.1,123.1 c-1.2,0-2.2,0.5-4.2,1.6c-3.9,2.1-18.8,13.4-20.6,15l0,0c-1.5,1.4-3.3,4.1-4.1,6.2c-3,8,8.8,22.1,14.6,25.9 c2.4,1.6,4.9,2.7,7.5,4c6.6,3.1,14,6.6,19.1,17.1c5.6,11.6,15.6,19.2,29.6,22.5l1.1,0.3c12.3,3,22.9,5.5,28.4,3.1 c3-1.9,5.8-7.1,5.4-8.5c-3.1-2.1-10.7-5.9-16.8-9c-2-1-3.8-1.9-5.4-2.7l-1-0.5l-0.5-1c-3.1-7-15.3-39.3-16.7-47.7 c-0.6-3.9-1.3-4.3-5.3-3.8l-0.9,0.1c-5,0.6-15.4,2-22.7-7.8c-4.6-6.2-3.5-10.7-2.9-13.1c0,0,0-0.1,0-0.1l-0.1,0 C169.5,123.5,168.2,123.1,167.1,123.1z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 195.2,
  y: 151.2,
  transform: "matrix(0.9742 -0.2256 0.2256 0.9742 -29.5577 50.2842)",
  className: "st0",
  width: 20.1,
  height: 6.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 198.9,
  y: 161.4,
  transform: "matrix(0.9742 -0.2256 0.2256 0.9742 -31.7509 51.3862)",
  className: "st0",
  width: 20.1,
  height: 6.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 202.6,
  y: 171.5,
  transform: "matrix(0.9742 -0.2256 0.2256 0.9742 -33.9444 52.4879)",
  className: "st0",
  width: 20.1,
  height: 6.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 206.3,
  y: 181.7,
  transform: "matrix(0.9742 -0.2256 0.2256 0.9742 -36.138 53.5899)",
  className: "st0",
  width: 20.1,
  height: 6.5
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M185.1,79.2c54.8,0,99.3,44.5,99.3,99.3c0,54.8-44.5,99.3-99.3,99.3s-99.3-44.5-99.3-99.3 C85.8,123.7,130.3,79.2,185.1,79.2z M185.1,68c-61,0-110.5,49.5-110.5,110.5c0,61,49.5,110.5,110.5,110.5 c61,0,110.5-49.5,110.5-110.5C295.6,117.5,246.1,68,185.1,68z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M98.2,88.8"
})))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M139.7,209.8c0.6-0.8,1.6-1.2,2.6-1c1,0.1,1.8,0.8,2.2,1.7c2.5,6.1,7.4,17.6,13.9,29.9 c-15.8,1.8-31.2,2.1-39.2,2.2c-1.1,0-2.1-0.6-2.6-1.6c-0.5-1-0.3-2.1,0.3-3L139.7,209.8z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M76.6,162.4c-13.2-18.3-18.3-34.4-13.3-42.1c2.5-3.9,8-6.3,15.6-7c3.4-4,7-7.7,10.8-11.3 c-16.9-0.9-29.7,2.9-35.8,12.2C34.5,143.9,90,199.3,126.6,226l7-8.7C112.9,202.2,91.4,183,76.6,162.4z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M228.6,149.1c-0.6,0.8-1.6,1.2-2.6,1c-1-0.1-1.8-0.8-2.2-1.7c-2.5-6.1-7.4-17.6-14-29.9 c15.8-1.8,31.2-2.1,39.2-2.2c1.1,0,2.1,0.6,2.6,1.6c0.5,1,0.3,2.1-0.3,3L228.6,149.1z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M291.7,196.5c13.2,18.3,18.3,34.4,13.3,42.1c-2.5,3.9-8,6.3-15.6,7c-3.4,4-7,7.7-10.8,11.3 c16.9,0.9,29.7-2.9,35.8-12.2c19.4-29.7-36.1-85.1-72.7-111.8l-7,8.7C255.4,156.7,276.8,175.8,291.7,196.5z"
})))));

function SvgNavigateFitness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 368.5 368.5",
    style: {
      enableBackground: "new 0 0 368.5 368.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateFitness);
export default __webpack_public_path__ + "static/media/NavigateFitness.2152ee4d.svg";
export { ForwardRef as ReactComponent };